import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { resolveMicaRedirectDestination } from "../../utils/micaRedirectUrls";

/**
 * Single public return point for MICA flows (payments, platform connect).
 * Opens WhatsApp with a prefilled message via wa.me.
 */
const MicaRedirectPage = () => {
  const [searchParams] = useSearchParams();

  const destination = useMemo(
    () => resolveMicaRedirectDestination(searchParams),
    [searchParams]
  );

  useEffect(() => {
    if (destination) {
      window.location.replace(destination);
    }
  }, [destination]);

  return (
    <div style={styles.wrap}>
      <p style={styles.text}>
        {destination
          ? "Volviendo a Mica…"
          : "No se pudo abrir WhatsApp. Falta configurar el número de Mica."}
      </p>
    </div>
  );
};

const styles = {
  wrap: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "system-ui, sans-serif",
    background: "#f5f5f5",
  },
  text: {
    margin: 0,
    fontSize: 18,
    color: "#333",
  },
};

export default MicaRedirectPage;
